import { render, staticRenderFns } from "./ModalGlobalMessage.vue?vue&type=template&id=1ed25e48"
import script from "./ModalGlobalMessage.vue?vue&type=script&lang=js"
export * from "./ModalGlobalMessage.vue?vue&type=script&lang=js"
import style0 from "./ModalGlobalMessage.vue?vue&type=style&index=0&id=1ed25e48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports